export enum TrainingGrantsActions {
  Reset = "reset",
  FetchTrainingGrants = "fetchTrainingGrants",
  FetchTrainingGrant = "fetchTrainingGrant",
  AddTrainingGrant = "addTrainingGrant",
  EditTrainingGrant = "editTrainingGrant",
}
